export const maxReferenceYear = (): number => new Date().getFullYear();
